import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const BudgetTypes = {
  DailyStandard: 'DailyStandard',
  LifetimeBudgetStandard: 'LifetimeBudgetStandard',
};


const formatBudget = (i18n, data, currencyCode) => {
  if (!data) {
    return i18n.getString(_TL_('No budget'));
  }

  const { Amount, Id, Type } = data;

  if (Id) {
    return i18n.getString(_TL_('Budget applied from shared library'));
  }

  const currencySymbol = i18n.getCurrencySymbol(currencyCode);

  if (Type === BudgetTypes.LifetimeBudgetStandard) {
    return `${currencySymbol}${Amount}/${i18n.getString(_TL_('lifetime'))}`;
  }

  return `${currencySymbol}${Amount}/${i18n.getString(_TL_('day'))}`;
};

export const Budget = ({ data, currencyCode }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Budget') }}>
      <Text>{formatBudget(i18n, data, currencyCode)}</Text>
    </PropertyRow>
  );
};

Budget.propTypes = {
  data: PropTypes.shape({}),
  currencyCode: PropTypes.string,
};

Budget.defaultProps = {
  data: null,
  currencyCode: 'USD',
};
